import { render, staticRenderFns } from "./EditMonthlyCategoryAmount.vue?vue&type=template&id=b68844c4&scoped=true"
import script from "./EditMonthlyCategoryAmount.vue?vue&type=script&lang=js"
export * from "./EditMonthlyCategoryAmount.vue?vue&type=script&lang=js"
import style0 from "./EditMonthlyCategoryAmount.vue?vue&type=style&index=0&id=b68844c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b68844c4",
  null
  
)

export default component.exports